<script lang="ts">
    import Accordion from '$lib/components/_DisplayComponents/Accordion/Accordion.svelte';
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import { personalizeText, getColor } from '$lib/helper';

    // Types
    import type { Component } from '$lib/types/Components/SharedTypes';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';
    import type { TrackingProperty } from '$lib/types/TrackingProperty';
    import type { Language } from '$lib/types/Language';
    import type { AccordionContent } from '$lib/types/Components/Accordion/AccordionContent';

    export let content: AccordionContent;
    export let childComponents: Component[] = [];
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let campaignId = '';
    export let trackingProperties: TrackingProperty[] = [];
    export let theme: Theme;
    export let language: Language = 'de';
    export let layout = DEFAULT_LAYOUT;

    const items = childComponents.map((item) => {
        const title = item.components[0];
        const body = item.components[1];

        return {
            bgColor: item.content.box.backgroundColor,
            title: {
                draft: personalizeText(
                    title.content.wysiwyg,
                    trackingProperties,
                    campaignId,
                    language,
                ),
                color: getColor(title.content.color, theme.fontColor),
                linkColor: theme.buttonBackgroundColor,
            },
            body: {
                draft: body.content.wysiwyg,
                color: getColor(body.content.color, theme.fontColor),
                linkColor: theme.buttonBackgroundColor,
            },
        };
    });
</script>

<svelte:component
    this={Accordion}
    {items}
    {transitionDelay}
    {transitionEffect}
    box={content.box}
    {layout}
/>
